// FILE EXTENSIONS
export const FILE_EXTENSION_CSV = 'csv';
export const FILE_EXTENSION_XLSX = 'xlsx';